module.exports = __webpack_public_path__ + "img/4_88.b7e80183.png";